import { render, staticRenderFns } from "./GpNumber.vue?vue&type=template&id=61130e5d&"
import script from "./GpNumber.vue?vue&type=script&lang=js&"
export * from "./GpNumber.vue?vue&type=script&lang=js&"
import style0 from "./GpNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports